import type { AxiosResponse } from "axios";
import { BASE_URL, httpClient, NAV_URL } from "../config/develop-config";

const baseUrl = `${BASE_URL}/auth`;

const getTempCreditLimit = async (
  company: string,
  search?: string,
  startDate?: string,
  endDate?: string,
  status?: string,
  sortField?: string,
  sortDirection?: string,
  page?: number,
  take?: number,
) => {
  const params = {
    company: company,
    search: search,
    startDate: startDate,
    endDate: endDate,
    status: status,
    sortField: sortField,
    sortDirection: sortDirection,
    page: page,
    take: take,
  };
  return await httpClient
    .get(`${baseUrl}/temporary-credit-limit/temporary-credit-limit`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getShopCreditLimit = async (
  company: string,
  search?: string,
  zone?: string,
  sortField?: string,
  sortDirection?: string,
  page?: number,
  take?: number,
) => {
  const params = {
    company: company,
    search: search,
    zone: zone,
    sortField: sortField,
    sortDirection: sortDirection,
    page: page,
    take: take,
  };
  return await httpClient
    .get(`${baseUrl}/temporary-credit-limit/shop-credit-limit`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const createTempCreditLimit = async (data: object) => {
  return await httpClient
    .post(`${baseUrl}/temporary-credit-limit/create-temporary-credit-limit`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const updateTempCreditLimit = async (data: object) => {
  return await httpClient
    .post(`${baseUrl}/temporary-credit-limit/update-temporary-credit-limit`, data)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getShopDetail = async (cusComId: number) => {
  return await httpClient
    .get(`${baseUrl}/temporary-credit-limit/credit-limit-shop-detail/${cusComId}?type=BO`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getTempCreditLimitDetail = async (temporaryCreditLimitId: string) => {
  return await httpClient
    .get(
      `${baseUrl}/temporary-credit-limit/temporary-credit-limit-detail/${temporaryCreditLimitId}`,
    )
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const deleteTempCreditLimit = async (temporaryCreditLimitId: string, updatedBy: string) => {
  const params = {
    temporaryCreditLimitId: temporaryCreditLimitId,
    updatedBy: updatedBy,
  };
  return await httpClient
    .delete(`${baseUrl}/temporary-credit-limit/delete-temporary-credit-limit`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const historyTempCreditLimit = async (temporaryCreditLimitId: string) => {
  return await httpClient
    .get(
      `${baseUrl}/temporary-credit-limit/history-temporary-credit-limit/${temporaryCreditLimitId}`,
    )
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const countTempCreditLimit = async (temporaryCreditLimitId: string) => {
  return await httpClient
    .get(`${baseUrl}/temporary-credit-limit/count-tab-edit-temp/${temporaryCreditLimitId}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getCountCredit = async (company: string) => {
  return await httpClient
    .get(`${baseUrl}/temporary-credit-limit/count-tab-credit-limit/${company}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const syncCredit = async (company?: string, customerNo?: string) => {
  return await httpClient
    .post(`${NAV_URL}/customer/sync-credit-limit-customer`, {
      company: company,
      customerNo: customerNo,
    })
    .then((res: AxiosResponse) => res.data);
};
const getOrderCreditLimit = async (
  company: string,
  status: string,
  searchText?: string,
  waitApprove?: string,
  startDate?: string,
  endDate?: string,
  sortBy?: string,
  sortDirection?: string,
  page?: number,
  take?: number,
  customerCompanyId?: string,
) => {
  const params = {
    company: company,
    searchText: searchText,
    waitApprove: waitApprove,
    startDate: startDate,
    endDate: endDate,
    status: status,
    sortBy: sortBy,
    sortDirection: sortDirection,
    page: page,
    take: take,
    customerCompanyId: customerCompanyId,
  };
  return await httpClient
    .get(`${BASE_URL}/order-cart/over-credit/order-list`, { params })
    .then((res: AxiosResponse) => res.data?.responseData)
    .catch((err) => console.log(err));
};
const getStatusRequestCredit = async (orderId: string) => {
  return await httpClient
    .get(`${BASE_URL}/order-cart/over-credit/${orderId}`)
    .then((res: AxiosResponse) => res.data?.responseData)
    .catch((err) => console.log(err));
};
export {
  createTempCreditLimit,
  getTempCreditLimit,
  getShopDetail,
  getTempCreditLimitDetail,
  updateTempCreditLimit,
  deleteTempCreditLimit,
  historyTempCreditLimit,
  countTempCreditLimit,
  getShopCreditLimit,
  getCountCredit,
  syncCredit,
  getOrderCreditLimit,
  getStatusRequestCredit,
};
